import { cn } from "@/lib/utils";

interface BadgeProps {
  variant: "pro" | "exp";
  /** "md" is the prominent card badge; "sm" is the inline/label badge. */
  size?: "sm" | "md";
  /** Override label (e.g. localized "EXPERIMENTAL"). Defaults per variant. */
  label?: string;
  className?: string;
}

/** PRO / EXPERIMENTAL pill used across cards, tool pages, and form labels. */
export function Badge({ variant, size = "sm", label, className }: BadgeProps) {
  const text = label ?? (variant === "pro" ? "PRO" : "EXPERIMENTAL");

  if (variant === "exp") {
    return (
      <span
        className={cn(
          "inline-flex flex-none items-center rounded-full border border-dashed border-accent/60 px-[7px] py-[2.5px] text-[9px] font-bold leading-none tracking-[0.5px] text-accent",
          className,
        )}
      >
        {text}
      </span>
    );
  }

  if (size === "md") {
    return (
      <span
        className={cn(
          "inline-flex flex-none items-center rounded-full border-2 border-gold bg-accent px-[9px] py-1 text-[10px] font-bold leading-none tracking-[0.5px] text-white shadow-[0_1px_2px_rgba(26,24,22,0.18)]",
          className,
        )}
      >
        {text}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex flex-none items-center rounded-full border-[1.5px] border-gold bg-accent px-[7px] py-[2.5px] text-[9px] font-bold leading-none tracking-[0.5px] text-white",
        className,
      )}
    >
      {text}
    </span>
  );
}
